module.exports = __webpack_public_path__ + "img/check-icon.9aa018ad.svg";